/** One label/value line in a Review & Submit step - shared by the travel
 *  request wizard and the standalone advance request's own review screen. */
export function SummaryRow({
  label,
  value,
  destructive
}: {
  label: string;
  value: React.ReactNode;
  destructive?: boolean;
}) {
  return (
    <div className="flex flex-col gap-0.5 border-b pb-2 sm:flex-row sm:justify-between sm:gap-4">
      <span className="text-muted-foreground sm:shrink-0">{label}</span>
      <span
        className={`min-w-0 break-words sm:text-right ${destructive ? "font-medium text-destructive" : "font-medium"}`}
      >
        {value}
      </span>
    </div>
  );
}
